import { HttpResult, Unit } from 'widgets-for-react'
import { JotFormControl, parseFormBuilderField, parseJotformField } from './jotform.parser'
import { Form, Question } from './jotform.state'

type FormResponse = { Questions: { content: { [key: string]: JotFormControl } }; Thankurl: string | null }

export const getQuestions = async (id: string): Promise<HttpResult<Form>> => {
  const res = await fetch(`/api/v1/jotform/form/${id}`)
  if (!res.ok) return { kind: 'failed', status: res.status }
  try {
    const json: FormResponse = await res.json()
    return {
      kind: 'result',
      status: res.status,
      value: {
        questions: Object.values(json.Questions.content)
          .sort((fieldA, fieldB) => parseInt(fieldA.order) - parseInt(fieldB.order))
          .map(parseJotformField)
          .filter((f) => f != undefined),
        thankurl: json.Thankurl || '',
      },
    }
  } catch (e) {
    console.error(`Error when fetching form [${id}]`)
    console.error(JSON.stringify(e))
    return { kind: 'failed', status: res.status }
  }
}

export const submit = async (id: string, questions: Question[]): Promise<HttpResult<Unit>> => {
  const formData = new FormData()
  // See Jotform API: https://api.jotform.com/docs/#post-form-id-submissions
  questions.map((field) => {
    if (field.kind != 'submitButton') {
      parseFormBuilderField(field).keys.map((qid, i) => {
        if (field.kind == 'checkbox') {
          // Creates string: `submission[1][0]=Option 1&submission[1][1]=Option 2&submission[1][2]=Option3`
          parseFormBuilderField(field)
            .value.map((val, valIndex) => formData.append(`submission[${qid}][${valIndex}]`, val))
            .join('&')
        } else {
          formData.append(`submission[${qid}]`, parseFormBuilderField(field).value[i])
        }
      })
    }
  })

  const result = await fetch(`/api/v1/jotform/form/${id}`, {
    method: 'POST',
    body: formData,
  })

  try {
    return { kind: 'result', status: result.status, value: result }
  } catch (e) {
    console.error(`Error when submitting form [${id}]`)
    console.error(JSON.stringify(e))
    return { kind: 'failed', status: result.status }
  }
}
